import { render, staticRenderFns } from "./CustomersLoans.vue?vue&type=template&id=0016bb10&scoped=true&"
import script from "./CustomersLoans.vue?vue&type=script&lang=js&"
export * from "./CustomersLoans.vue?vue&type=script&lang=js&"
import style0 from "./CustomersLoans.vue?vue&type=style&index=0&id=0016bb10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0016bb10",
  null
  
)

export default component.exports